/**
 * Manufacturing Loan Insert Service
 * Migrated from 3in1cms/bajajfinserv-web/ui.solid/src/lib/api/mflInsertApi.ts
 */

import { request } from "../core/request";
import { OPERATION_IDS } from "./constants";
import type { IMFLInsertRequest, IMFLApiResponse } from "../types/mflInsertApiTypes";

/**
 * Manufacturing Loan Insert API
 * @param requestData - Manufacturing loan insert request data
 * @returns Promise of Manufacturing loan insert response
 */
export const mflInsert = async (requestData: IMFLInsertRequest): Promise<IMFLApiResponse> => {
  const response = (await request<IMFLApiResponse>({
    operationId: OPERATION_IDS.mflInsert,
    requestData,
  })) as IMFLApiResponse;

  return response;
};
